import React from 'react';
import { LoanType } from '@apply/constants';
import { ShowIf } from '../../../components/ShowIf';
import { CompensationExpectation } from './components/CompensationExpectation';
import { FinalizeThirdPartyName } from './components/FinalizeThirdPartyName';
import { useBorrowerLoanType } from '../../../../queries/BorrowerFields/CoreFields';
import { useBorrowerThirdPartyExpectation } from '../../../../queries/BorrowerFields/ThirdPartyFields';

export const ThirdPartyCompensation: React.FC = () => {
    const [loanType] = useBorrowerLoanType();
    const [finalizeThirdPartyClaim] = useBorrowerThirdPartyExpectation();

    return (
        <>
            <ShowIf showIf={loanType !== LoanType.SubNoteConstruction && loanType !== LoanType.SubNoteFixFlip}>
                <CompensationExpectation />
            </ShowIf>
            <ShowIf showIf={finalizeThirdPartyClaim ?? false}>
                <FinalizeThirdPartyName />
            </ShowIf>
        </>
    );
};
